import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "button",
    "panel",
    "mainMenu",
    "feedbackForm",
    "positiveFeedbackForm",
    "negativeFeedbackForm",
    "suggestionForm",
    "successMessage",
    "feedbackText"
  ]

  // Use an arrow function so the reference is stable
  handleClickOutside = (event) => {
    if (!this.element.contains(event.target) && this.isPanelVisible()) {
      this.closePanel()
    }
  }

  connect() {
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  togglePanel() {
    this.isPanelVisible() ? this.closePanel() : this.showPanel()
  }

  showPanel() {
    this.panelTarget.classList.remove("d-none")
    this.showMainMenu()
  }

  closePanel() {
    this.panelTarget.classList.add("d-none")
    this.resetAllViews()
  }

  // --- DRY helper: hide everything except one target ---
  showOnly(target) {

    this.resetAllViews()

    target.classList.remove("d-none")
    target.classList.add("d-block")
  }

  showMainMenu() {
    this.showOnly(this.mainMenuTarget)
  }

  showPositiveFeedback() {
    this.showOnly(this.positiveFeedbackFormTarget)
  }

  showNegativeFeedback() {
    this.showOnly(this.negativeFeedbackFormTarget)
  }

  showFeedback() {
    this.showOnly(this.feedbackFormTarget)
  }
  
  showSuggestion() {
    this.showOnly(this.suggestionFormTarget)
  }

  async submitFeedback(type) {
    const feedback = this.feedbackTextTargets.find(target => target.dataset.feedbackType === type).value.trim()
    if (feedback) {
      try {
        const response = await fetch('/help/feedback', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            feedback: {
              type: type,
              text: feedback,
              page_url: window.location.href,
              page_path: window.location.pathname,
              page_query: window.location.search,
              page_title: document.title,
              referrer: document.referrer
            }
          })
        })

        if (response.ok) {
          this.showSuccessMessage()
          this.feedbackTextTarget.value = ''
        } else {
          console.error('Failed to submit feedback')
        }
      } catch (error) {
        console.error('Error submitting feedback:', error)
      }
    }
  }

  submitPositiveFeedback() {
    this.submitFeedback('positive')
  }

  submitNegativeFeedback() {
    this.submitFeedback('negative')
  }

  submitSuggestion() {
    this.submitFeedback('suggestion')
  }

  showSuccessMessage() {
    this.showOnly(this.successMessageTarget)
    setTimeout(() => {
      window.location.reload()
    }, 3000);
  }

  resetAllViews() {
    this.mainMenuTarget.classList.add("d-none")
    this.feedbackFormTarget.classList.add("d-none")
    this.positiveFeedbackFormTarget.classList.add("d-none")
    this.negativeFeedbackFormTarget.classList.add("d-none")
    this.suggestionFormTarget.classList.add("d-none")
    this.successMessageTarget.classList.add("d-none")
  }

  isPanelVisible() {
    return !this.panelTarget.classList.contains("d-none")
  }
}
